<template>
  <div class="vx-row" id="container">
    <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base" v-if="dataReady">
      <vs-button @click="$emit('close')" color="primary" type="border" icon-pack="feather"
        icon="icon-arrow-left"></vs-button>
      <vx-card>
        <info valueSize="26px" label="GR #" :value="gt.grNumber" />
        <info valueSize="26px" label="Master Stock Code" :value="masterStockCode" />
        <info valueSize="26px" label="Status" :value="gt.status" />

        <div class="flex flex-col md:flex-row">
          <div class="w-full md:w-1/2 bg-gray-100">
            <info label="Sub Stock Code" :value="subStockCode" />
            <info label="Company" :value="gt.compId" />
            <info label="Line Description" :value="gt.lineDescription" />
            <info label="Stock Balance" :value="gt.stockBalance + ' ' + gt.unit" />

            <info label="Supplier Name" :value="supplierName" />
            <info label="Received By" :value="gt.receivedBy" />
          </div>

          <div class="w-full md:w-1/2 bg-gray-200">
            <info label="Stock" :value="gt.stock" />
            <info label="Gasket Type" :value="infoData.gasketType" />
            <info label="Gasket Type Detail" :value="infoData.gasketDetails" />
            <info label="Size / Dimension" :value="gt.sizeDimension" />
            <info label="Thickness" :value="gt.thickness" />
            <info label="Supplier Doc #" :value="gt.supplierDocNumber" />
            <info label="Qty Received" :value="gt.qtyReceived" />
            <info label="Remark" :value="gt.remarks" />
          </div>
        </div>

      </vx-card>
    </div>
    <div class="vx-col w-full md:w-2/3 text-center align-right" v-if="dataReady">

      <div class="flex flex-wrap-reverse items-center">


        <vs-row class="pb-5">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <h3>QR Code</h3>
          </vs-col>
        </vs-row>

      </div>

      <div class="flex flex-wrap-reverse items-center">


        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <VueQRCodeComponent class=" bg-white p-10" error-level="L" :text="masterStockCode + '|' + subStockCode"
              :size="300" />
          </vs-col>
        </vs-row>

      </div>

 
    </div>
  </div>
</template>

<script>
//get the profile/setCurrentMainInfo from the store
import { mapGetters } from "vuex";
import { helperMixin } from "../../mixin/helperMixin";
import info from "./info.vue"
import StockTable from "@/components/aron/table/stockMovement.vue";
import { axiosMixin } from "@/mixin/axiosMixin.js";
import VueQRCodeComponent from 'vue-qrcode-component'
export default {
  mixins: [helperMixin, axiosMixin],
  props: ["id"],
  components: {
    info,
    StockTable,
    VueQRCodeComponent
  },
  data() {
    return {
      infoData: {},
      dataReady: false,
      masterStockCode: '',
      subStockCode: '',
      supplierName: '',
    };
  },
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#container",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    getData() {
      this.startLoading();
      this.aronPost(
        'getGrDataForViewDetailsPage',
        {
          masterStockCode: this.gt.masterStockCode,
          subStockCode: this.gt.subStockCode,
          supplierId: this.gt.supplier,
        },
        '',
        ''
      )
        .then(response => {
          if (response.status) {
            this.infoData = response.data.data;
            this.masterStockCode = response.data.masterStockCode;
            this.subStockCode = response.data.subStockCode;
            this.supplierName = response.data.supplierName;
          } else {
            this.errorAlert('Error', response.data.error)
          }
          this.dataReady = true;
          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error)
          this.stopLoading('loader')
        })
    },
    dsv(value, options) {
      return this.decodeValueForSelect(options, value);
    },

  },
  computed: {
    ...mapGetters({
      gt: "profile/gt",
      gd: "profile/gd",
    }),
    filterEndpoint() {
      return "search_goodsreceives";
    },
    filter() {
      return { advanceFilter: { masterStockCode: this.gt.masterStockCode } }
    }
  },

  mounted() {
    this.dataReady = false;
    this.getData();
  }
};

</script>
